import styled from 'styled-components'

export const Icon = styled.div`
  width: 3rem;
  display: flex;
  margin-left: 1rem;
`

export const LogoImg = styled.img`
    width: 5rem;
    height: 3rem;
    margin-top: 10px;
`

export const LogoTitle = styled.h2`
    font-size: 3rem;
    margin: 0;
    font-weight: 300;
    color: #131B23;

    span {
      color: #D6A449;
    }
`
